export const isBrowser = () =>
  typeof window !== "undefined" && typeof window.document !== "undefined";

export const renameKeys = (object, adapter) => {
  return Object.entries(object).reduce((mem, [key, value]) => {
    return {
      ...mem,
      [adapter(key)]: value,
    };
  }, {});
};
